import { getDefaultExportFromCjs } from './_virtual-_commonjsHelpers.js';
import { __require as requireEsCookie } from './node_modules-es-cookie-src-es-cookie.js';

var esCookieExports = requireEsCookie();
var Cookies = /*@__PURE__*/getDefaultExportFromCjs(esCookieExports);

export { Cookies as default };
//# sourceMappingURL=_virtual-es-cookie.js.map
